import React from 'react'

const Track = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg
        width="52"
        height="48"
        viewBox="0 0 52 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M11.1188 16.8594H0.642578"
            stroke="#686058"
            strokeWidth="1.28571"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.6382 27.4385L15.2691 11.3761C17.952 10.7944 33.5985 11.1677 37.3216 14.1371C39.0553 15.5219 39.8962 18.3307 41.3611 19.1251C42.9648 19.9933 44.7982 20.3276 46.5102 20.9571C52.0927 23.0235 50.697 29.2053 50.697 29.2053C51.3818 29.8869 51.2041 32.739 50.359 32.739L45.6217 32.8042C45.6217 33.8795 45.1952 34.9108 44.436 35.6712C43.6768 36.4316 42.6471 36.8588 41.5735 36.8588C40.4999 36.8588 39.4702 36.4316 38.711 35.6712C37.9518 34.9108 37.5253 33.8795 37.5253 32.8042H26.8631C26.8631 33.8795 26.4366 34.9108 25.6775 35.6712C24.9183 36.4316 23.8886 36.8588 22.815 36.8588C21.7413 36.8588 20.7117 36.4316 19.9525 35.6712C19.1933 34.9108 18.7668 33.8795 18.7668 32.8042L12.1138 32.7434C11.9361 32.7173 12.3608 29.8001 12.3608 29.8001"
            stroke="#686058"
            strokeWidth="1.28571"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.35547 25.4297H10.165"
            stroke="#686058"
            strokeWidth="1.28571"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.45215 21.6211H11.1188"
            stroke="#686058"
            strokeWidth="1.28571"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default Track
